<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';
import { isNilOrEmpty } from '~/utils';

const props = defineProps({
  compromisso: {
    default: null,
    type: Object,
  },
});

const emit = defineEmits(['close', 'loaded', 'success', 'error']);

const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <div>
    <CompromissoCommandForm2
      :command="compromisso.command2"
      :show-upload-files="false"
      :submit-button-disabled="!isNilOrEmpty(compromisso)
        && compromisso.responsavel.codigo !== authStore.codigoUsuario"
      :initial-model="{
        compromissoCodigos: props.compromisso ? [props.compromisso.codigo] : null,
      }"
      @close="() => emit('close')"
      @submit-success="() => emit('success')"
    >
      <template #form>
        <a-row>
          <a-col :span="24">
            <a-alert
              type="warning"
              show-icon
            >
              <template #message>
                Caso você tenha enviado o email sobre o acordo ao banco com as
                informações dos compromissos anteriores, clique no botão de
                confirmação
              </template>
            </a-alert>
            <div style="margin-top: 24px;" />
          </a-col>
        </a-row>
      </template>
    </CompromissoCommandForm2>
  </div>
</template>
